import React, { useEffect, useState } from "react";
import TextAreaModalProps from "./TextAreaModal.types";
import "./TextAreaModal.scss";
import Button from "../Button/Button";
import Text from "../Text/Text";
import { makeStyles, TextareaAutosize } from "@material-ui/core";
import ModalUI from "@material-ui/core/Modal";
import SVG from "../SVG/SVG";

function rand() {
  return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: "16px",
    borderRadius: 4,
    fontSize: 10,
  },
  box: {
    display: "flex",
    justifyContent: "space-between",
  },
  subBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

const TextAreaModal = ({
  isPartialAccept =false,
  maxQuantity,
  title,
  modalBtnText,
  imageText,
  handleClick,
  openModal = false,
  call,
  reset,
}: TextAreaModalProps) => {
  const classes = useStyles();
  // getModalStyle is not a pure function, we roll the style only on the first render
  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(openModal);
  const [expandModal, setExpandModal] = React.useState(false);
  const [textError, setTextError] = React.useState(false);
  const [userText, setUserText] = React.useState("");
  const [partialQuantityError, setPartialQuantityError] = React.useState(false);
  const [partialQuantity, setPartialQuantity]= React.useState("");
  const [quantityWarning, setQuantityWarning]= React.useState(false);
  // const [imageModal, setImageModal] = React.useState(showImageModal); doesnt work when useState is used here, so using the showImageModal directly!!
  const alphaNumbericRegex = /^[a-zA-Z0-9\s]{0,}$/;
  useEffect(() => {
    setOpen(openModal);
    setUserText("");
    //checking screen size and displaying modal pop up
    if (window.innerWidth > 430) {
      setExpandModal(false);
    } else {
      setExpandModal(true);
    }
  }, [openModal]);

  const [windowDimenion, detectHW] = useState({
    winWidth: window.innerWidth,
    winHeight: window.innerHeight,
  });

  const detectSize = () => {
    detectHW({
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
    });
  };

  useEffect(() => {
    window.addEventListener("resize", detectSize);

    return () => {
      window.removeEventListener("resize", detectSize);
    };
  }, [windowDimenion]);

  useEffect(() => {
    if (windowDimenion.winWidth > 430) {
      setExpandModal(false);
    } else {
      setExpandModal(true);
    }
  }, [windowDimenion]);

  const handleOpen = () => {
    setOpen(true);
    // handleClick();
  };
  const handleClose = () => {
    setUserText("");
    setPartialQuantity("")
    setOpen(false);
    reset();
  };
  const submit = () => {
    if (userText.length > 0) {
      setTextError(false);
      isPartialAccept &&partialQuantity  && setPartialQuantityError(false);
      isPartialAccept? call({userText, partialQuantity}):call(userText);
    } else {
      setTextError(true);
      isPartialAccept && !partialQuantity && Number(partialQuantity)>maxQuantity && setPartialQuantityError(true);
    }
    setUserText("");
    setPartialQuantity("")
  };

  const body = (
    <div
      style={modalStyle}
      className={(expandModal ? "modal85" : "modal25") + " " + classes.paper}
    >
      <div className={classes.box}>
        <h2 className="title" id="simple-modal-title">
          {title}
        </h2>
        <p onClick={() => handleClose()} className="mt-0">
          <SVG type="close" />
        </p>
      </div>
      {isPartialAccept&&<div>
        <div className="flexItem">
          <div className="fs-14 fw-500 mb pr">Enter Quantity*:</div>
          <input
            type="number"
            className="mb-1 input-height"
            placeholder="Enter quantity"
            value={partialQuantity}
            onChange={(e: any) => {
              if(!/^\d{1,10}(\.\d{0,2})?$/.test(e.target.value)) return false;
              if (maxQuantity && ((e.target.value)>maxQuantity || (e.target.value)<=0)){
                setQuantityWarning(true);
                return false;
              }else{
                setQuantityWarning(false);
              }//
              setPartialQuantity(e.target.value);
              if (e.target.value.length > 0) {
                setPartialQuantityError(false);
              } else {
                setPartialQuantityError(true);
              }
            }}
          />
        </div>
        <Text
          type={`${quantityWarning ? "danger" : "normal"}`}
          fonts="normal"
          fontSize={14}
          className={`mt0 mb0 pb0 d-flex h-end padding ${
            quantityWarning ? "" : "hidden"
          }`}
        >
          Quantity greater than 0 and less than {maxQuantity+1}
        </Text>
        <Text
          type={`${partialQuantityError ? "danger" : "normal"}`}
          fonts="normal"
          fontSize={14}
          className={`mt0 mb0 pb0 d-flex h-end padding ${
            partialQuantityError ? "" : "hidden"
          }`}
        >
          This field is required
        </Text>
      </div>}

      <div className="fs-14 fw-500 mb">Reason*</div>
      <div>
        <TextareaAutosize
          maxRows={4}
          aria-label="maximum height"
          placeholder="Write description here"
          className="w-100"
          style={{ height: "7rem" }}
          value={userText}
          onChange={(e: any) => {
            if (alphaNumbericRegex.test(e.target.value)) {
              setUserText(e.target.value);
              if (e.target.value.length > 0) {
                setTextError(false);
              } else {
                setTextError(true);
              }
            }
          }}
        />
        <Text
          type={`${textError ? "danger" : "normal"}`}
          fonts="normal"
          fontSize={14}
          className={`mt0 mb0 pb0 d-flex h-end padding ${
            textError ? "" : "hidden"
          }`}
        >
          This field is required
        </Text>
      </div>
      <Button className="mt-1" onClick={() => submit()} isRounded={true}>
        Submit
      </Button>
    </div>
  );
  return (
    <div className="btn-container">
      {/* <button onClick={() => handleOpen()}>click</button> */}
      {open && (
        <ModalUI
          open={open}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
        >
          {body}
        </ModalUI>
      )}
    </div>
  );
};

export default TextAreaModal;
